import { EMPTY_ARRAY } from 'utils/clickme';

import { setCampaignExcludedRegions, setCampaignRegions, setIsRootRegionSelected } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const clearRegions = (): AppThunkAction<void> => (dispatch) => {
    dispatch([
        setCampaignRegions(EMPTY_ARRAY),
        setCampaignExcludedRegions(EMPTY_ARRAY),
        setIsRootRegionSelected(false),
    ]);
};
